export enum SearchEvents {
  ENTER_ARTICLE = 'enter-article',
  SEARCH_BAR_SEARCH = 'search-bar-search',
  SEARCH_HOT_KEYWORD_SEARCH = 'search-hot-keyword-search',
  SEARCH_ARTICLE_HASHTAG_SEARCH = 'search-article-hashtag-search',
  SEARCH_RESULT_LIST_SEARCH = 'search-result-list-search',
}
